import { authAxiosInstance, axiosInstance } from "./axiosInstance";
import { getLocalStorageItem, setLocalStorageItem } from "./storage";
import { API_ENDPOINTS } from "./constants";

const getSsoUrl = async (): Promise<string | undefined> => {
	try {
		const response = await authAxiosInstance.get(`${API_ENDPOINTS.SSO_SIGN_IN}`);
		return response.data?.result?.redirectUrl;
	} catch (error) {
		console.error("Error fetching SSO URL:", error);
		return undefined;
	}
};

export const redirectToSso = async () => {
	console.log("Redirecting to SSO...");
	try {
		const ssoRedirectUrl = await getSsoUrl();
		console.log("ssoRedirectUrl: ", ssoRedirectUrl);
		if (ssoRedirectUrl) {
			window.location.href = ssoRedirectUrl;
		} else {
			console.error("SSO Redirect URL is undefined");
		}
	} catch (error) {
		console.error("Error occurred during SSO redirection:", error);
	}
};

export const getSsoTokenQueryParamValue = () => {
	const searchParams = new URLSearchParams(window.location.search);
	const token = searchParams.get("SsoToken");
	return token;
};

export const refreshAccessToken = async () => {
	try {
		const response = await authAxiosInstance.post(API_ENDPOINTS.REFRESH_TOKEN, {
			email: getLocalStorageItem("E_MAIL"),
			token: getLocalStorageItem("ACCESS_TOKEN"),
			isMobil: false,
		});
		if (response.data.isSuccessful) {
			setLocalStorageItem("ACCESS_TOKEN", response.data?.result?.token);
			return true;
		} else {
			console.log("REFRESH_TOKEN error");
		}
	} catch (error: any) {
		if (error.response && error.response.status === 401) {
			redirectToSso();
		} else {
			console.log(error);
		}
	}
};

export const getAccessToken = async (ssoToken: string) => {
	try {
		const response = await authAxiosInstance.get(`${API_ENDPOINTS.SSO_CALLBACK}/?ssoToken=${ssoToken}`);
		return response.data;
	} catch (error) {
		return false;
	}
};

export const checkUserClaims = async () => {
	try {
		const response = await axiosInstance.get(API_ENDPOINTS.CHECK_USER_CLAIMS);
		return response.data;
	} catch (error) {
		return console.log(error);
	}
};